import { Component, Input, PLATFORM_ID, Inject } from '@angular/core';
import { SlugifyService } from 'src/app/core/services/slugify.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-trending-card',
  templateUrl: './trending-card.component.html',
  styleUrls: ['./trending-card.component.scss']
})
export class TrendingCardComponent {
  @Input() blogId: number = 0;
  @Input() heading: string = '';
  @Input() topicName: string = '';
  @Input() shortTitle: string = '';
  @Input() readTime: string = '2 min read';
  isBrowser: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private slugifyService: SlugifyService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  slugify(input: string): string {
    return this.slugifyService.slugify(input);
  }
  scrollToTop() {
    if (this.isBrowser) {
      window.scrollTo(0, 0);
    }
  }
}
